import React, { useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import FeedbackStatusesContent from "./FeedbackStatusesContent";
import ApplicationNavigation from "constants/navigation/applicationNavigation";

function FeedbackStatuses() {
	// Init params
	const { id } = useParams();

	// Init hooks
	const location = useLocation();

	// Init state
	const [is404, setIs404] = useState(false);
	const navigation = ApplicationNavigation(id);

	if (is404 === false) {
		return (
			<FeedbackStatusesContent
				navigation={navigation}
				id={id}
				setIs404={setIs404}
				state={location.state}
			/>
		);
	} else {
		return <p>404: Application id {id} does not exist.</p>;
	}
}

export default FeedbackStatuses;
